import TiltifyIcon from '@svg/tiltify-icon.jsx';
import { openTiltifyOAuthPopup } from '@util/tiltifyHelper.js';
import PropTypes from 'prop-types';

TiltifyOAuthButton.propTypes = {
  setTiltifyUser: PropTypes.func,
};

/**
 * Handles the Tiltify OAuth button and login state. Login state is based on the presence of a username field.
 * @returns
 */
export function TiltifyOAuthButton({
  setTiltifyUser = (user) => {
    console.warn('setTiltifyUser not handled', user);
  },
}) {
  return (
    <>
      <div className="my-4">
        <a
          className="btn btn-secondary tiltify w-full"
          data-track="tiltify-oauth-setup"
          onClick={() => openTiltifyOAuthPopup(setTiltifyUser)}
        >
          Connect to Tiltify
          <TiltifyIcon classname="w-7 h-7 ml-2 mr-0 inline" />
        </a>
      </div>
    </>
  );
}
